import * as React from 'react';
import classNames from 'classnames';
import SvgSprite from 'src/react/components/html-elements/SvgSprite';
import { AvatarBadgeType } from 'ui/avatar/types';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import { FC } from 'react';

const AvatarBadge: FC<AvatarBadgeType> = ({
  icon,
  text,
  style = Variant.primary,
}) => {
  if (!icon && typeof text === 'undefined') {
    return null;
  }

  return (
    <div
      className={classNames(
        `avatar-badge badge badge-pill badge-${style}`,
        { 'badge-square': icon },
      )}
    >
      {text ?? <SvgSprite id={icon} size={10} />}
    </div>
  );
};

export { AvatarBadge };
